import Api from "../api";

export default async function apiDeleteUser(id: string) {
  return await Api.delete<string>({
    input: `/api/v1/user/${id}`,
  });
}
